import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", href: "#top" },
  { label: "今日热榜", href: "#hot" },
  { label: "合集汇总", href: "#collections" },
  { label: "事件时间线", href: "#timeline" },
  { label: "精华内容", href: "#featured" },
  { label: "打包下载", href: "#download" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onLight = scrolled;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        onLight ? "bg-background-50/95 shadow-soft backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <nav className="container-gua flex h-16 items-center justify-between">
        <a
          href="#top"
          className="flex items-center gap-2 whitespace-nowrap"
          onClick={() => setOpen(false)}
        >
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-lg text-xl ${
              onLight ? "bg-primary-500 text-background-50" : "bg-background-50/20 text-background-50"
            }`}
          >
            <i className="ri-radio-2-line"></i>
          </span>
          <span
            className={`font-heading text-xl font-bold tracking-wide ${
              onLight ? "text-foreground-900" : "text-background-50"
            }`}
          >
            呱呱<span className="text-primary-500">爆料</span>
          </span>
        </a>

        <ul className="hidden items-center gap-7 lg:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`whitespace-nowrap text-sm font-medium transition-colors ${
                  onLight
                    ? "text-foreground-700 hover:text-primary-600"
                    : "text-background-100 hover:text-background-50"
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <a
            href="#download"
            className={`hidden whitespace-nowrap items-center gap-1.5 rounded-md px-4 py-2 text-sm font-medium transition sm:inline-flex ${
              onLight
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50 text-primary-700 hover:bg-background-200"
            }`}
          >
            <i className="ri-download-2-line text-base"></i>
            打包下载
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setOpen((v) => !v)}
            className={`flex h-10 w-10 items-center justify-center rounded-md border lg:hidden ${
              onLight
                ? "border-background-200 text-foreground-800"
                : "border-background-50/40 text-background-50"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div
          className="border-t border-background-200 bg-background-50 lg:hidden gua-fade-up"
        >
          <ul className="container-gua flex flex-col py-3">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block border-b border-background-100 py-3 text-sm font-medium text-foreground-800 hover:text-primary-600"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}